export const admissionStatus = {
  new: "New",
  admitted: "Admitted",
  discharged: "Discharged"
};
